(function () {
  if (window.__wishlistInitDone) return;
  window.__wishlistInitDone = true;

  const STORAGE_KEY = 'site_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function refreshHeartStates() {
    const list = getWishlist();
    document.querySelectorAll('.wishlist-heart-btn').forEach(function (btn) {
      const handle = btn.getAttribute('data-wishlist-handle');
      if (list.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  // 다른 스크립트(facets.js 등)에서 직접 호출할 수 있도록 전역 노출
  window.refreshWishlistHearts = refreshHeartStates;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.wishlist-heart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-wishlist-handle');
    let list = getWishlist();

    if (list.indexOf(handle) === -1) {
      list.push(handle);
      btn.classList.add('is-active');
    } else {
      list = list.filter(function (h) { return h !== handle; });
      btn.classList.remove('is-active');
    }

    saveWishlist(list);

    // 위시리스트 페이지 등 다른 컴포넌트에 갱신 신호
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }, true);

  document.addEventListener('DOMContentLoaded', refreshHeartStates);
  // 무한스크롤/필터링(AJAX)으로 카드가 늦게 로드되는 경우 대비
  document.addEventListener('wishlist:refresh-needed', refreshHeartStates);

  // 스크립트가 DOMContentLoaded 이후에 로드된 경우를 대비한 즉시 실행
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    refreshHeartStates();
  }
})();
